import {create} from 'zustand';

type State = {
    avatarUrl : string,
}

type Action = {
    updateUrl : (avatarUrl: State['avatarUrl']) => void
}

const useAvatarStore = create<State & Action>((set)=>({
    avatarUrl : '/logo_variant.svg',
    updateUrl : (avatar_url) => set(() => ({avatarUrl : avatar_url}))
}));


export default useAvatarStore;
